
import React from 'react'
import ReactDOM from 'react-dom';
import { connect } from "react-redux"

import { fetchVideos, fetchTherapyAreas, fetchTherapyCategories } from "../../actions/index"
import { adminCreateVideo, adminDeleteVideo } from "../../actions/admin"
import { setTitle } from "../../actions/index"

import closeImage from '../../images/icons/close_black.svg';

import AdminVideo from './AdminVideo'

//import styles
//import './styles/AdminVideos.scss';



@connect(store => {
  return {
    videos: store.videos,
    User: store.User.User,
    therapy_areas: store.therapy_areas,
    therapy_categories: store.therapy_categories,
    app: store.app,
    practice_types: store.practice_types
  };
})
class AdminVideos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openNewItem: false,
      filterByPracticeType: "5e673f588be36a0015b15299",
      newItem: {
        name: "",
        description: "",
        code: "",
        practice_type: ""
      }
    };
    this.handleNewItemChange = this.handleNewItemChange.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.setNewItem = this.setNewItem.bind(this);
    this.handleNewItemSubmit = this.handleNewItemSubmit.bind(this);
    this.toggleNewItem = this.toggleNewItem.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.setup = this.setup.bind(this);
  }

  componentDidUpdate(nextProps) {
		const { User } = this.props;

		if (User.token && User.name != nextProps.User.name) {
			this.setup();
		}
	}

  componentDidMount() {
    const { User } = this.props;

		if (User.token && User.name != '') {
			this.setup();
		}
  }

  setup() {
    this.props.dispatch(setTitle("Admin: Videos"));
    this.props.dispatch(fetchVideos());
    this.props.dispatch(fetchTherapyAreas());
    this.props.dispatch(fetchTherapyCategories());

    this.setState({
      newItem: {
        name: "",
        description: "",
        code: "",
        practice_type: this.state.filterByPracticeType
      }
    })
  }

  handleNewItemChange(e, field) {
    let newItem = this.state.newItem;
    newItem[field] = e.target.value;
    this.setNewItem(newItem);
  }

  handleDelete(id) {
    if (confirm("Really delete this Video?")) {
      this.props.dispatch(adminDeleteVideo(id));
    }
  }

  handleNewItemSubmit(e) {
    e.preventDefault();
    if (this.state.newItem.name !== "") {
      this.props.dispatch(adminCreateVideo(this.state.newItem));
    }
    this.setNewItem({
      name: "",
      description: "",
      code: "",
      practice_type: ""
    });
    this.toggleNewItem();
  }

  handleFilterChange(event) {
    this.setState({ filterByPracticeType: event.target.value });
    this.setState({
      newItem: {
        name: "",
        description: "",
        code: "",
        practice_type: event.target.value
      }}
    )
  }

  setNewItem(newItem) {
    this.setState({
      newItem: newItem
    });
  }

  toggleNewItem() {
    this.setState({ openNewItem: !this.state.openNewItem });

    // slide page down too
    let page = ReactDOM.findDOMNode(this.refs.page);
    let addNewItem = ReactDOM.findDOMNode(this.refs.addNewItem);
    let transform = this.state.openNewItem ? 0 : addNewItem.offsetHeight;
    page.style.transition = "0.34s transform ease-out";
    page.style.transform = `translateY(${transform}px)`;
  }

  render() {
    return (<main className="main adminVideos">
        <div
          ref="addNewItem"
          className={
            this.state.openNewItem
              ? "addItem--wrapper open"
              : "addItem--wrapper"
          }
        >
          <form onSubmit={this.handleProfessionChange}>
            {this.props.practice_types.length > 1 ? (
              <div className="selectLabel">
                HEALTHCARE PROFESSION::
                <select
                  className="md-input md-title professionSelect"
                  value={this.state.newItem.practice_type}
                  onChange={e => this.handleNewItemChange(e, "practice_type")}
                >
                  {this.props.practice_types.map(type => (
                    <option key={type.id} value={type.id}>
                      {type.practice_type}
                    </option>
                  ))}
                </select>
              </div>
            ) : (
              ""
            )}
            <br />
            <input
              className="md-input md-title"
              onChange={event => this.handleNewItemChange(event, "name")}
              value={this.state.newItem.name}
              type="text"
              placeholder="Video title"
              contentEditable="true"
            />
            <br />
            <br />
            <input
              className="md-input md-title"
              onChange={event => this.handleNewItemChange(event, "code")}
              value={this.state.newItem.code}
              type="text"
              placeholder="Video Code"
              contentEditable="true"
            />
            <br />
            <br />
            <textarea
              className="md-input multiple"
              value={this.state.newItem.description}
              placeholder="Video description"
              onChange={event => this.handleNewItemChange(event, "description")}
            />
            <p>
              <br />
              <button
                className="md-button md-raised md-primary"
                onClick={this.handleNewItemSubmit}
              >
                Create
              </button>
            </p>
          </form>
          <a
            href="#"
            onClick={this.toggleNewItem}
            className="top-draw-handle  md-button-fab"
          >
            <img
              alt="Close"
              className={
                "open-close " + (this.state.openNewItem ? "close" : "")
              }
              src={closeImage}
            />
          </a>
        </div>
        <div ref="page">
          {this.props.practice_types.length > 1 ? (
            <div className="select my1 p1">
              Profession:
              <select
                value={this.state.filterByPracticeType}
                onChange={this.handleFilterChange}
              >
                {this.props.practice_types.map(type => (
                  <option key={type.id} value={type.id}>
                    {type.practice_type}
                  </option>
                ))}
              </select>
            </div>
          ) : (
            ""
          )}
          <div className="card ">
            <div className="card-content">
              <small className="md-caption">
                Get the code from the Youtube url: [v=code].
                <br />
                Eg: 'https://www.youtube.com/watch?v=_qixMnBDaw4' = _qixMnBDaw4
              </small>
            </div>
          </div>
          <div className="video-grid grid mb8">
            {Object.values(this.props.videos)
              .filter(
                vid => vid.practice_type === this.state.filterByPracticeType
              )
              .map(video => (
                <div key={video._id}>
                  <AdminVideo
                    handleDelete={this.handleDelete}
                    item={video}
                    selectPracticeType={this.state.filterByPracticeType}
                  />
                </div>
              ))}
          </div>
        </div>
      </main>
    )
  }
}

export default AdminVideos;



// WEBPACK FOOTER //
// ./src/components/admin/AdminVideos.jsx